module.exports = __webpack_public_path__ + "5f27e9d3993fdfd5bada13ac362f2af2.pdf";